<template>
  <div style="all: initial">
    <PageTitle titleText="駐車場等お申し込み"></PageTitle>
    <div class="c-allocation-index__wrap">
      <div
        v-for="(allocation, index) in allocations"
        :key="index"
        class="c-allocation-index"
      >
        <div
          v-if="allocation.status == '受付期間'"
          class="c-allocation-deadlineText"
        >
          申込締切：{{
            $date(allocation.reception_range[1]).tz().format("YYYY-MM-DD HH:mm")
          }}まで
        </div>
        <div
          v-else-if="allocation.status == '抽選中'"
          class="c-allocation-deadlineText"
        >
          抽選中
        </div>
        <div
          v-else-if="allocation.status == '抽選結果公開'"
          class="c-allocation-deadlineText"
        >
          抽選結果公開
        </div>
        <div
          v-html="allocation.memo"
          class="ck-content c-allocation-note"
        ></div>
        <button
          @click="onNext(allocation)"
          class="c-allocation-Button"
          :disabled="disabledEntry(allocation.reception_range)"
          :class="
            disabledEntry(allocation.reception_range)
              ? 'c-allocation-Button__disabled'
              : ''
          "
        >
          {{ allocation.name }}
        </button>
        <div v-if="entries[index]" class="c-allocation-done">
          {{ $date(entries[index].updatedAt).tz().format("YYYY-MM-DD") }} 申込済み
        </div>
      </div>
      <div v-if="allocations.length == 0">
        現在抽選申込期間外です。<br />申込期間になりましたら、トップページにてお知らせいたします。
      </div>
    </div>
  </div>
</template>

<script>
import AllocationService from "@/services/allocation.service";
import AllocationEntryService from "@/services/allocation-entry.service";
import PageTitle from "@/components/PageTitle.vue";

export default {
  components: {
    PageTitle,
  },
  data() {
    return {
      allocations: [],
      entries: [],
    };
  },
  async mounted() {
    const cs = await AllocationService.checkStatuses();
    console.log("cs", cs);

    const result = await AllocationService.find({
      where: {
        mansion: this.currentUser.mansion._id,
        $or: [
          { status: "受付期間" },
          { status: "抽選中" },
          { status: "抽選結果公開" },
        ],
      },
      option: {
        sort: { "sort_order": 1 },
      },
    });

    this.allocations = result.data;
    console.log("allocations=", this.allocations);
    // 申込済みかどうかを確認する
    this.entries = [];
    console.log("user", this.currentUser._id);
    for (let index = 0; index < this.allocations.length; index++) {
      const allocation = this.allocations[index];
      const result = await AllocationEntryService.find({
        where: {
          allocation: allocation._id,
          user: this.currentUser._id,
        },
      });
      if (result.data.length > 0) {
        this.entries.push({
          allocation: result.data[0]._id,
          updatedAt: result.data[0].updatedAt,
        });
      } else {
        this.entries.push(null);
      }
    }
    console.log("entries", this.entries);
  },
  methods: {
    disabledEntry(date) {
      return (
        this.$date().isBetween(date[0], date[1]) === false &&
        !this.isPermission("Admin")
      );
    },
    isDuring(allocation) {
      return this.$date().isBetween(
        allocation.reception_range[0],
        allocation.reception_range[1],
      );
    },
    onNext(allocation) {
      if (this.isPermission("Admin")) {
        this.$router.push({
          name: "allocation-entry",
          params: { id: allocation._id },
        });
        return;
      }
      if (allocation.status == "受付期間") {
        if (this.isDuring(allocation)) {
          this.$router.push({
            name: "allocation-entry",
            params: { id: allocation._id },
          });
        } else {
          this.$message({
            message: "申込期間外です",
            type: "warning",
          });
        }
      } else if (allocation.status == "抽選中") {
        this.$router.push({
          name: "allocation-lottery",
          params: { id: allocation._id },
        });
      } else if (allocation.status == "抽選結果公開") {
        this.$router.push({
          name: "allocation-result",
          params: { id: allocation._id },
        });
      }
    },
  },
};
</script>
